import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import Translation from '@swf/components/Translation/Translation';
import { select } from '@swf/core/store';

import useBetSlipMaxHeight from '../../hooks/useBetSlipMaxHeight';
import useCloseReceiptOnLogout from '../../hooks/useCloseReceiptOnLogout';
import useOpenReceiptOnMobile from '../../hooks/useOpenReceiptOnMobile';
import CollapsibleLayout from '../CollapsibleLayout/CollapsibleLayout';
import Title from '../Title/Title';

import {
  TXTWCL_Bet_Placed_2,
  TXTWCL_Bet_Receipt,
  TXTWCL_Bets_Placed_1,
  TXTWCL_Multiples,
  TXTWCL_Singles
} from './BetReceipt.messages.json';
import styles from './BetReceipt.scss';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import ReceiptItems from './components/ReceiptItems/ReceiptItems';
import Totals from './components/Totals/Totals';

const BetReceipt: React.FC = () => {
  const receiptItems = useSelector(select.betSlip.receipt);
  const totalBetsCount = receiptItems.SINGLE.length + receiptItems.MULTIPLE.length;
  const hasOneBet = totalBetsCount === 1;

  useOpenReceiptOnMobile();
  useCloseReceiptOnLogout();

  const { betSlipRef } = useBetSlipMaxHeight();

  return (
    <CollapsibleLayout
      ref={betSlipRef}
      header={
        <Header
          title={<Translation {...(hasOneBet ? TXTWCL_Bet_Placed_2 : TXTWCL_Bets_Placed_1)} />}
        />
      }
      showMobileHeader={totalBetsCount > 0}
      main={
        <div className={styles.betReceipt}>
          <div className={styles.content}>
            <Totals />
            <div className={styles.title}>
              <Translation {...TXTWCL_Bet_Receipt} />
            </div>
            <ReceiptItems
              open={hasOneBet}
              title={
                <Title count={receiptItems.MULTIPLE.length || undefined}>
                  <Translation {...TXTWCL_Multiples} />
                </Title>
              }
              receiptItems={receiptItems.MULTIPLE}
            />
            <ReceiptItems
              open={hasOneBet}
              title={
                <Title count={receiptItems.SINGLE.length || undefined}>
                  <Translation {...TXTWCL_Singles} />
                </Title>
              }
              receiptItems={receiptItems.SINGLE}
            />
          </div>
          <Footer />
        </div>
      }
    />
  );
};

export default memo(BetReceipt);
